import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Wrapper from "../UI/Wrapper";
import "./executionDoc.css";
import VaccinationModal from "../OrderDetailsAllDoc/VaccinationBook_Doc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from '@fortawesome/free-solid-svg-icons';
// import { faArrowUpCircle } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const steps = [1, 2, 3, 4, 5];
// progress bar code
const ExecutionDoc = ({ Relocation_Id }) => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    if (currentStep < steps.length) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const [isOpen1, setIsOpen1] = useState(false);

  const openModal = () => setIsOpen1(true);
  const closeModal = () => setIsOpen1(false);

  const navigate = useNavigate();
  // row color change
  const [rows, setRows] = useState([]);

  const rowColorChange = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f6f3ff" : "white",
    color: "black",
  });

  const handleVendorChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].Vendor_id = value; // Updated to match the JSON key
    setRows(newRows);
  };

  const handleFileChange1 = (index, file) => {
    const newRows = [...rows];
    newRows[index].Receipt = file; // Updated to match the JSON key
    setRows(newRows);
  };

  // row color change end
  // progress bar code

  const [ownerName, setOwnerName] = useState("Mukul Sharma");
  const [lastUpdated, setLastUpdated] = useState("2024-04-03");
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpdate = () => {
    alert(`Updated Owner Name: ${ownerName}, Last Updated: ${lastUpdated}`);
  };

  const handleUpload = () => {
    if (file) {
      alert(`File Uploaded: ${file.name}`);
    } else {
      alert("No file chosen!");
    }
  };
  return (
    <>
      <div>
        <div>
          <Wrapper className="LeadDetails">
            {/* ----------------------------------Upload Documents-------------------------------------- */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >

              {/* <button className="open-modal-button" onClick={openModal}>
        Open Vaccination Book
      </button> */}
              {isOpen1 && <VaccinationModal closeModal={closeModal} />}

              <div className="viewLeadDetails-form" style={{ border: "none" }}>
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr>
                    <td colSpan={4}>
                      <table style={{ width: "100%" }}>
                        <tr className="viewLeadDetailsHeading">
                          <th
                            style={{
                              background: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                              width: "87%",
                              borderRight: "1px solid white",
                              borderTopRightRadius: "1px",
                              borderBottomRightRadius: "1px",
                            }}
                          >
                            <span style={{ fontSize: "18px" }}>
                              {" "}
                              Upload Documents{" "}
                            </span>
                          </th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  {/* bar code */}
                  {/* <div className="container"> */}
                  <div
                    className="current_step_div row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "99%",
                      border: "1px solid",
                      height: "5rem",
                      padding: "10px 6px",
                      marginLeft: "9px",
                      borderRadius: "7.5px",
                    }}
                  >
                    {/* Left-aligned Step */}
                    <div className="col-2">
                      <span style={spanFsize}>Step {currentStep}</span>
                    </div>

                    {/* Right-aligned Buttons */}
                    <div className="col-10" style={{ textAlign: "end" }}>
                      <button
                        className="open-modal-button"
                        style={{ marginRight: "10px" }}
                        onClick={() => navigate("/RffitLaboratories", { state: { Relocation_Id } })}
                      >
                        RffitLaboratori
                      </button>
                      <button
                        className="open-modal-button"
                        style={{ marginRight: "10px" }}
                        onClick={() => navigate("/titer-form", { state: { Relocation_Id } })}
                      >
                        Titer Form
                      </button>
                      <button
                        className="open-modal-button"
                        style={{ marginRight: "10px" }}
                        onClick={() => navigate("/bioBest", { state: { Relocation_Id } })}
                      >
                        BioBest
                      </button>
                      <button className="open-modal-button" style={{ marginRight: "10px" }} onClick={openModal}>
                        Test
                      </button>
                      <button style={{ marginRight: "10px" }}>
                        Generate Itinerary
                      </button>
                      <button style={styles.Downloadallbutton}>
                        <FontAwesomeIcon icon={faDownload} style={styles.Downloadallicon} />
                        Download All
                      </button>
                    </div>
                  </div>

                  <div className="progress-bar">
                    <div
                      className="progress-line"
                      style={{
                        width: `${((currentStep - 1) / (steps.length - 1)) * 100
                          }%`,
                      }}
                    ></div>

                    {steps.map((step, index) => (
                      <div key={step} className="step-container">
                        <div
                          className={`step-number ${index + 1 <= currentStep ? "active" : ""
                            }`}
                        >
                          {`0${step}`}
                        </div>
                      </div>
                    ))}
                  </div>


                  {/* bar code  */}
                  {/* first Step Start */}
                  {currentStep === 1 && (
                    <>
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          1. Updated Vaccination Book.

                        </h3>
                        <p style={styles.subHeading}>
                          A record of a pet's vaccination history, detailing dates and types of vaccines administered. {" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Owner's Name (Mentioned in the document)
                              </label>
                              <div style={inputContainerStyle}>
                                <input
                                  type="text"
                                  id="date"
                                  placeholder="Enter"
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Last date of vaccination book updated.
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Card start */}

                        <div
                          style={{
                            ...styles.card,
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={styles.cardHeader}>
                            <strong>Vaccination Book</strong>
                            <br></br>
                            <span>Tue, 07 May 2024 | 11:45 AM</span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <button
                              // onClick={() => deleteDoc(item.doc_ID)}
                              style={{
                                display: "flex",
                                height: "35px",
                                width: "100%",
                                marginLeft: "5px",
                                color: "#FF0004",
                                fontSize: "16px",
                                fontWeight: '600',
                                borderStyle: "none",
                                background: "none",
                                padding: "10px 0 0 0",
                              }}
                            >
                              Delete{" "}
                              <DeleteOutlinedIcon
                                className="icon"
                                style={{ padding: "0 0 0 4px" }}
                              />
                            </button>

                            <a
                              style={{
                                display: "flex",
                                color: "#00A3FF",
                                textDecoration: "none",
                                cursor: "pointer",
                                fontWeight: "bold",
                                width: "100%",
                                padding: "10px",
                              }}
                            // target="_blank"
                            // href={${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}}
                            // rel="noopener noreferrer"
                            >
                              Preview{" "}
                              <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                style={{
                                  padding: "5px 4px 0px 11px",
                                  color: "#00A3FF",
                                }}
                              />
                            </a>
                            <button
                              style={{
                                color: "#28A745",
                                width: "100%",
                                marginTop: "4px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                display: "flex",
                              }}
                              className="btn btn-success inputDoc3"
                            // onClick={() => submitDocument(item.doc_ID)}
                            >
                              Submit{" "}
                              <FontAwesomeIcon
                                icon={faArrowRightFromBracket}
                                style={{
                                  padding: "5px 4px 0px 11px",
                                  color: "#28A745",
                                }}
                              />
                            </button>
                          </div>
                        </div>
                        {/* Card end */}
                      </div>


                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          2. Insertion of a Microchip.

                        </h3>
                        <p style={styles.subHeading}>
                          A microchip is a permanent proof of identification. Standard pet microchips are of the ISO 11784/11785 variety.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Microchip Number
                              </label>
                              <div style={inputContainerStyle}>
                                <input
                                  type="text"
                                  id="date"
                                  placeholder="Enter"
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of microchip inserted. (Before rabies vaccination)
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Card start */}

                        <div
                          style={{
                            ...styles.card,
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={styles.cardHeader}>
                            <strong>Microchip Certificate </strong>
                            <br></br>
                            <span>Sat, 11 May 2024 | 10:30 AM</span>
                          </div>
                          {/* <div>
                        <span>Tue, 07 May 2024 | 11:45 AM</span>
                      </div> */}
                          {/* Card */}

                          <div style={{ display: "flex" }}>
                            <button
                              // onClick={() => deleteDoc(item.doc_ID)}
                              style={{
                                display: "flex",
                                height: "35px",
                                width: "100%",
                                marginLeft: "5px",
                                color: "#FF0004",
                                fontSize: "16px",
                                fontWeight: '600',
                                borderStyle: "none",
                                background: "none",
                                padding: "10px 0 0 0",
                              }}
                            >
                              Delete{" "}
                              <DeleteOutlinedIcon
                                className="icon"
                                style={{ padding: "0 0 0 4px" }}
                              />
                            </button>

                            <a
                              style={{
                                display: "flex",
                                color: "#00A3FF",
                                textDecoration: "none",
                                cursor: "pointer",
                                fontWeight: "bold",
                                width: "100%",
                                padding: "10px",
                              }}
                            // target="_blank"
                            // href={${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}}
                            // rel="noopener noreferrer"
                            >
                              Preview{" "}
                              <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                style={{
                                  padding: "5px 4px 0px 11px",
                                  color: "#00A3FF",
                                }}
                              />
                            </a>
                            <button
                              style={{
                                color: "#28A745",
                                width: "100%",
                                marginTop: "8px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                display: "flex",
                              }}
                              className="btn btn-success inputDoc3"
                            // onClick={() => submitDocument(item.doc_ID)}
                            >
                              Submit{" "}
                              <FontAwesomeIcon
                                icon={faArrowRightFromBracket}
                                style={{
                                  padding: "5px 4px 0px 11px",
                                  color: "#28A745",
                                }}
                              />
                            </button>
                          </div>
                          {/* Card end */}
                        </div>
                        {/* Card end */}
                      </div>
                    </>
                  )}
                  {/* First Step End  */}

                  {/* second Step Start */}
                  {currentStep === 2 && (
                    <>
                      {/* Administer Rabies Vaccine */}
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          1. Administer Rabies Vaccine to the Pet.(Post Microchip)
                        </h3>
                        <p style={styles.subHeading}>
                          The first step for a titre test is to give the pet a
                          rabies Vaccine. it is mandatory to insert a microchip
                          before giving the rabies vaccine to the pet.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div style={containerStyle}>
                          <label htmlFor="date" style={labelStyle}>
                            Date of rabies vaccination.
                          </label>
                          <div style={inputContainerStyle}>
                            <input type="date" id="date" style={inputStyle} />
                            <button
                              style={buttonStyle}
                              onMouseOver={(e) =>
                              (e.target.style.backgroundColor =
                                buttonHoverStyle.backgroundColor)
                              }
                              onMouseOut={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* Administer Rabies Vaccine End */}

                      {/* Blood Sample Collection */}
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          2. Blood Sample Collection.
                        </h3>
                        <p style={styles.subHeading}>
                          After the day of rabies vaccination,we will wait for 30
                          days. On the 31st day, we will Collect a blood sample
                          from the pet. A 90-day cool-off period starts during
                          which the pet cannot travel{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div style={containerStyle}>
                          <label htmlFor="date" style={labelStyle}>
                            Date of blood smple collection.
                          </label>
                          <div style={inputContainerStyle}>
                            <input type="date" id="date" style={inputStyle} />
                            <button
                              style={buttonStyle}
                              onMouseOver={(e) =>
                              (e.target.style.backgroundColor =
                                buttonHoverStyle.backgroundColor)
                              }
                              onMouseOut={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* Blood Sample Collection End */}

                      {/* Rabies Serology From */}
                      <div style={styles.container}>
                        <h3 style={styles.heading}>3. Rabies Serology From.</h3>
                        <p style={styles.subHeading}>
                          We need to submit a Rabies Serology from along with the
                          blood to the laboratory. The choice of laboratory should
                          be based on the destination.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              Please select a from{" "}
                            </label>
                            <div
                              className="input-box"
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "8px",
                              }}
                            >
                              <input
                                type="text"
                                id="health-annexure"
                                placeholder="KVAFSU Laboratory"
                                readOnly
                                style={{
                                  width: "100%",
                                  height: "18%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  paddingRight: "40px",
                                  outline: "none",
                                }}
                              />
                              <a
                                href="#"
                                className="open-link"
                                title="Open Health Annexure Form"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18"
                                  height="18"
                                  style={{ fill: "#6a0dad" }}
                                >
                                  <path d="M14 3h7v7h-2V6.41l-8.29 8.3-1.42-1.42L17.59 5H14V3zm-4 6H3v12h12v-7h-2v5H5V11h5V9z" />
                                </svg>
                              </a>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              className="input-box"
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "39px",
                              }}
                            >
                              <input
                                type="text"
                                id="health-annexure"
                                placeholder="Biobest Laboratory"
                                readOnly
                                style={{
                                  width: "100%",
                                  height: "18%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  paddingRight: "40px",
                                  outline: "none",
                                }}
                              />
                              <a
                                href="#"
                                className="open-link"
                                title="Open Health Annexure Form"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18"
                                  height="18"
                                  style={{ fill: "#6a0dad" }}
                                >
                                  <path d="M14 3h7v7h-2V6.41l-8.29 8.3-1.42-1.42L17.59 5H14V3zm-4 6H3v12h12v-7h-2v5H5V11h5V9z" />
                                </svg>
                              </a>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              className="input-box"
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "39px",
                              }}
                            >
                              <input
                                type="text"
                                id="health-annexure"
                                placeholder="APHA Laboratory"
                                readOnly
                                style={{
                                  width: "100%",
                                  height: "18%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  paddingRight: "40px",
                                  outline: "none",
                                }}
                              />
                              <a
                                href="#"
                                className="open-link"
                                title="Open Health Annexure Form"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18"
                                  height="18"
                                  style={{ fill: "#6a0dad" }}
                                >
                                  <path d="M14 3h7v7h-2V6.41l-8.29 8.3-1.42-1.42L17.59 5H14V3zm-4 6H3v12h12v-7h-2v5H5V11h5V9z" />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: "12px" }}>
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of from submission
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Rabies Serology From End */}

                      {/*  */}
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          4. Upload the Titer Test report.
                          <span>(ID is required to verify the details)</span>
                        </h3>
                        <p style={styles.subHeading}>
                          A rabies titer test confirms the success of a rabies
                          vaccine & checks the number of antibodies in your pet's
                          blood{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Microchip Number
                              </label>
                              <div style={inputContainerStyle}>
                                <input
                                  type="text"
                                  id="date"
                                  placeholder="Enter"
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of blood sample collection
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* second Step End*/}

                  {/* thied Step Start */}
                  {currentStep === 3 && (
                    <>
                      {/* Address or ID Proof.*/}
                      <div style={styles.container}>
                        <h3 style={styles.heading}>1. Address or ID Proof.</h3>
                        <p style={styles.subHeading}>
                          We require the pet parent's address or ID proof to
                          verify the owner's address and ensure a smooth KYC
                          process.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>

                        <div className="row">
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              Date of Document submission
                            </label>
                            <div style={inputContainerStyle}>
                              <input type="date" id="date" style={inputStyle} />
                              <button
                                style={buttonStyle}
                                onMouseOver={(e) =>
                                (e.target.style.backgroundColor =
                                  buttonHoverStyle.backgroundColor)
                                }
                                onMouseOut={(e) =>
                                  (e.target.style.backgroundColor = "transparent")
                                }
                              >
                                Update
                              </button>
                            </div>
                          </div>
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              Upload Document{" "}
                            </label>
                            <div style={inputContainerStyle}>
                              <input type="file" id="date" style={inputStyle} />
                              <button
                                style={buttonStyle}
                                onMouseOver={(e) =>
                                (e.target.style.backgroundColor =
                                  buttonHoverStyle.backgroundColor)
                                }
                                onMouseOut={(e) =>
                                  (e.target.style.backgroundColor = "transparent")
                                }
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          2. Pan Card .
                          <span>
                            (A PAN card is required only if the invoice amount
                            exceeds ₹50,000)
                          </span>
                        </h3>
                        <p style={styles.subHeading}>
                          We require the PAN Card of the pet parent to ensure a
                          smooth KYC process.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Enter Pan Number
                              </label>
                              <div style={inputContainerStyle}>
                                <input
                                  type="text"
                                  id="date"
                                  placeholder="Enter"
                                  style={inputStyle}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of PAN Card submission
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>3. Passport Verification.</h3>
                        <p style={styles.subHeading}>
                          We need to verify the passport details of the pet parent
                          to ensure no discrepancies occur on the day of travel.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of passport submission
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Passport Validity
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>4. VISA Verification</h3>
                        <p style={styles.subHeading}>
                          We need to verify the VISA details of the pet parent to
                          ensure no discrepancies occur on the day of travel.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of VISA submission
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                VISA Validity{" "}
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>5. Air Ticket Verification</h3>
                        <p style={styles.subHeading}>
                          we need to verify the Air Ticket details of the pet
                          parentto ensure no discrepancies occur on the day of
                          travel{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              select origin{" "}
                            </label>
                            <select
                              style={{
                                height: "2.5rem",
                                width: "100%",
                                borderRadius: "7.5px",
                                border: "1px solid #ccc",
                                padding: "0 8px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                outline: "none",
                                cursor: "pointer",
                              }}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Arun Srivasatv">
                                Arun Srivasatv
                              </option>
                              <option value="Aayushi Aggarwal">
                                Aayushi Aggarwal
                              </option>
                            </select>
                          </div>
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              select Destination{" "}
                            </label>
                            <select
                              style={{
                                height: "2.5rem",
                                width: "100%",
                                borderRadius: "7.5px",
                                border: "1px solid #ccc",
                                padding: "0 8px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                outline: "none",
                                cursor: "pointer",
                              }}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Arun Srivasatv">
                                Arun Srivasatv
                              </option>
                              <option value="Aayushi Aggarwal">
                                Aayushi Aggarwal
                              </option>
                            </select>
                          </div>
                          <div className="col-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of Travel
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: "12px" }}>
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Date of air ticket submission
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Address or ID Proof. End */}
                    </>
                  )}
                  {/* thied step End  */}

                  {/* fourth step Start */}
                  {currentStep === 4 && (
                    <>
                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          1. Health Certificate Verification.
                        </h3>
                        <p style={styles.subHeading}>
                          During pet travel, we need to verify the pet's updated
                          health certificate, which is valid for 10 days.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Issue date of health certificate
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Health certificate validity
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          2. Parasite/ Screw/ Tapeworm Certificate Verification
                        </h3>
                        <p style={styles.subHeading}>
                          During pet travel, we need to verify the updated
                          parasite, screw, or tapeworm certificate of the pet. The
                          validity of this certificate is 05 days.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Issued date of parasite/screw/tapeworm
                                certificate.
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Certificate Validity or Date of arrival{" "}
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>
                          3. Health Annexure Verification
                        </h3>
                        <p style={styles.subHeading}>
                          During pet travel, we need to check or verify the health
                          annexure of the pet. The validity of this
                          certificate will be 5 days.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              Please select the service type{" "}
                            </label>
                            <select
                              style={{
                                height: "2.5rem",
                                width: "100%",
                                borderRadius: "7.5px",
                                border: "1px solid #ccc",
                                padding: "0 8px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                outline: "none",
                                cursor: "pointer",
                              }}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Arun Srivasatv">
                                Arun Srivasatv
                              </option>
                              <option value="Aayushi Aggarwal">
                                Aayushi Aggarwal
                              </option>
                            </select>
                          </div>
                          <div className="col-4">
                            <label htmlFor="health-annexure">
                              Fill out the health annexure
                            </label>
                            <div
                              className="input-box"
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "8px",
                              }}
                            >
                              <input
                                type="text"
                                id="health-annexure"
                                placeholder="Health Annexure Form"
                                readOnly
                                style={{
                                  width: "100%",
                                  height: "18%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  paddingRight: "40px",
                                  outline: "none",
                                }}
                              />
                              <a
                                href="#"
                                className="open-link"
                                title="Open Health Annexure Form"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18"
                                  height="18"
                                  style={{ fill: "#6a0dad" }}
                                >
                                  <path d="M14 3h7v7h-2V6.41l-8.29 8.3-1.42-1.42L17.59 5H14V3zm-4 6H3v12h12v-7h-2v5H5V11h5V9z" />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div className="row pt-3">
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Certificate Validity or Date of arrival{" "}
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* fourth step Start */}

                  {/* five step Start */}
                  {currentStep === 5 && (
                    <>
                      <div style={styles.container}>
                        <h3 style={styles.heading}>1. Import Permit</h3>
                        <p style={styles.subHeading}>
                          Before traveling, a pet parent needs to obtain an import
                          permit from the destination country. The permit will be
                          valid for 15-30 days.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Issue date of import permit
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Date input section */}
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Import permit Validity
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>2. Export NOC</h3>
                        <p style={styles.subHeading}>
                          Before the pet travels, we arrange the Export NOC for
                          the customer, which will be valid for 10 days.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Issued date of export NOC{" "}
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <label htmlFor="date" style={labelStyle}>
                              Vaccination Details{" "}
                            </label>
                            <select
                              style={{
                                height: "2.5rem",
                                width: "100%",
                                borderRadius: "7.5px",
                                border: "1px solid #ccc",
                                padding: "0 8px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                outline: "none",
                                cursor: "pointer",
                              }}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Arun Srivasatv">
                                Arun Srivasatv
                              </option>
                              <option value="Aayushi Aggarwal">
                                Aayushi Aggarwal
                              </option>
                            </select>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={styles.container}>
                        <h3 style={styles.heading}>3. Cargo (AWB)</h3>
                        <p style={styles.subHeading}>
                          In the end, for pet travel, we share the Cargo (AWB)
                          with the customer so they can start their
                          pet travel journey.{" "}
                          <a href="#more-info" style={styles.link}>
                            More Info
                          </a>
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <label htmlFor="health-annexure">
                              Fill out the Airway Bill
                            </label>
                            <div
                              className="input-box"
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "8px",
                              }}
                            >
                              <input
                                type="text"
                                id="health-annexure"
                                placeholder="Health Annexure Form"
                                readOnly
                                style={{
                                  width: "100%",
                                  height: "18%",
                                  padding: "10px",
                                  fontSize: "14px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  paddingRight: "40px",
                                  outline: "none",
                                }}
                              />
                              <a
                                href="#"
                                className="open-link"
                                title="Open Health Annexure Form"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18"
                                  height="18"
                                  style={{ fill: "#6a0dad" }}
                                >
                                  <path d="M14 3h7v7h-2V6.41l-8.29 8.3-1.42-1.42L17.59 5H14V3zm-4 6H3v12h12v-7h-2v5H5V11h5V9z" />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div className="row pt-3">
                          <div className="col-md-4">
                            <div style={containerStyle1}>
                              <label htmlFor="date" style={labelStyle}>
                                Issue date of cargo (AWB){" "}
                              </label>
                              <div style={inputContainerStyle}>
                                <input type="date" id="date" style={inputStyle} />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* File upload section */}
                          <div className="col-md-4">
                            <div style={{ ...containerStyle1 }}>
                              <label htmlFor="date" style={labelStyle}>
                                Upload Document{" "}
                              </label>

                              <div style={inputContainerStyle}>
                                <input
                                  type="file"
                                  id="date"
                                  onChange={handleFileChange}
                                  style={inputStyle}
                                />
                                <button
                                  style={buttonStyle}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor =
                                      buttonHoverStyle.backgroundColor;
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* five step Start */}
                  {/* bar code button */}
                  <div className="buttons" style={{ textAlign: "end" }}>
                    <button onClick={handlePrev} disabled={currentStep === 1}>
                      Previous
                    </button>
                    <button
                      onClick={handleNext}
                      disabled={currentStep === steps.length}
                    >
                      Next
                    </button>
                  </div>

                  {/* bar code end  */}
                </table>



                <table style={{ width: "100%" }}>
                  <tr className="viewLeadDetailsHeading">
                    <th
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                        width: "87%",
                        borderRight: "1px solid white",
                        borderTopRightRadius: "1px",
                        borderBottomRightRadius: "1px",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>
                        {" "}
                        Documents{" "}
                      </span>
                    </th>
                    <th
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                        width: "87%",
                        borderRight: "1px solid white",
                        borderTopLeftRadius: "1px",
                        borderBottomLeftRadius: "1px",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>
                        {" "}
                        Count: <span>15</span>{" "}
                      </span>
                    </th>
                  </tr>
                </table>

                <div className="row mt-5" style={{ padding: '0 11px 8px 12px' }}>
                  <div className="col-md-3 bg-gray-600" style={{ backgroundColor: '#EBEBEB', border: '1px solid #EBEBEB', padding: '12px' }}>Sales co-ordinator</div>
                  <div className="col-md-3 border-1px-solid" style={{ border: '1px solid #EBEBEB', padding: '12px' }}></div>
                  <div className="col-md-3 bg-gray-600 border-1px-solid" style={{ backgroundColor: '#EBEBEB', border: '1px solid #EBEBEB', padding: '12px' }}>Operations co-ordinator</div>
                  <div className="col-md-3 border-1px-solid" style={{ border: '1px solid #EBEBEB', padding: '12px' }}></div>
                </div>

                <table className="table">
                  <thead>
                    <tr className="scop_of_work_tr_th">
                      <th>S.No</th>
                      <th>Document Type</th>
                      <th>Upload Date & Time</th>
                      <th>Uploaded By</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Array.isArray(rows) &&
                      rows.map((row, index) => (
                        <tr key={row.Temp_ID} style={rowColorChange(index)}>
                          <td style={rowColorChange(index)}>
                            {/* {String(index + 1).padStart(2, "0")} */}
                            {String(row.Temp_ID).padStart(2, "0")}
                          </td>
                          <td style={rowColorChange(index)}>{row.Service}</td>
                          <td
                            style={rowColorChange(index)}
                            className={
                              row.Status === "REQUIRED"
                                ? "status-required"
                                : "status-not-required"
                            }
                          >
                            {row.Status}
                          </td>
                          <td style={rowColorChange(index)}>{row.Remark}</td>
                          <td style={rowColorChange(index)}>
                            <select
                              style={{
                                ...rowColorChange(index),
                                width: "13rem",
                                height: "2.5rem",
                                borderRadius: "7.5px",
                              }}
                              value={row.Vendor_id || ""}
                              onChange={(e) => handleVendorChange(index, e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Arun 	Srivasatv">Arun 	Srivasatv</option>
                              <option value="Aayushi	Aggarwal">Aayushi	Aggarwal</option>
                              <option value="Arun	Srivastava">Arun	Srivastava</option>
                              <option value="Mukul	Sharma">Mukul	Sharma</option>
                              <option value="Uthappa	Ganapathy">Uthappa	Ganapathy </option>
                              <option value="Aziz Ur	Rehman">Aziz Ur	Rehman</option>
                              <option value="SCOOBEE PET CAGES	PRIVATE LIMITED">SCOOBEE PET CAGES	PRIVATE LIMITED</option>
                            </select>
                          </td>
                          <td style={rowColorChange(index)}>
                            <input
                              style={{
                                border: "1px solid ",
                                borderRadius: "7.5px 0 0 7.5px",
                              }}
                              type="file"
                              onChange={(e) =>
                                handleFileChange1(index, e.target.files[0])
                              }
                            />
                          </td>
                          <td style={rowColorChange(index)}>
                            <button
                              style={{
                                ...rowColorChange(index),
                                borderRadius: "0 7.5px 7.5px 0",
                                height: "2.4rem",
                              }}
                              className="upload-button"
                              onClick={() => handleUpload(index)}
                            >
                              Upload
                            </button>
                          </td>
                          <td style={rowColorChange(index)}>
                            <button
                              style={{
                                ...rowColorChange(index),
                                borderRadius: "0 7.5px 7.5px 0",
                                height: "2.4rem",
                              }}
                              className="upload-button"
                              onClick={() => handleUpload(index)}
                            >
                              Upload
                            </button>
                          </td>
                          <td style={rowColorChange(index)}>
                            <button
                              style={{
                                ...rowColorChange(index),
                                borderRadius: "0 7.5px 7.5px 0",
                                height: "2.4rem",
                              }}
                              className="upload-button"
                              onClick={() => handleUpload(index)}
                            >
                              Upload
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Wrapper>
          <br />
        </div>
      </div>
    </>
  );
};

// Css ------------------------------------------------------------------------------------------------------ Css
const containerStyle = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "400px",
  // margin: "0 auto",
  fontFamily: "Arial, sans-serif",
};

const containerStyle1 = {
  display: "flex",
  flexDirection: "column",
  // margin: "0 auto",
  fontFamily: "Arial, sans-serif",
};

const labelStyle = {
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: '600',
  color: "#333",
};

const inputContainerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap", // For responsiveness
};

const inputStyle = {
  flex: "1",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid #ccc",
  height: "42.17px",
  borderRadius: "7.5px 0px 0px 7.5px ",
  minWidth: "0", // Prevents layout breaking on small screens
};

const buttonStyle = {
  padding: "8px 16px",
  fontSize: "14px",
  color: "#000000",
  backgroundColor: "transparent",
  border: "1px solid #4a56e2",
  borderRadius: "4px",
  height: "42.17px",
  borderRadius: "0px 7.5px 7.5px 0px",
  cursor: "pointer",
  flexShrink: "0", // Prevent button from shrinking
};

const buttonHoverStyle = {
  backgroundColor: "#6a5acd",
  color: "#white",
};

const spanFsize = {
  fontSize: "19px",
  fontWeight: "700"
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "20px",
    width: "100%",
    // maxWidth: "1000px",
    margin: "20px auto",
    backgroundColor: "#FAFAFA",
  },
  heading: { marginBottom: "5px" },
  subHeading: { fontSize: "14px", color: "#666" },
  link: { color: "#007bff", textDecoration: "none" },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "15px",
  },
  header: {
    backgroundColor: "revert",
    padding: '26px 0 0 14px',
    textAlign: "left",
    border: "1px solid #ddd",
    fontSize: "14px",
    color: "#333",
  },
  cell: {
    padding: "10px",
    //  border: "1px solid #ddd",
    verticalAlign: "top",
  },
  input: {
    width: "90%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  fileInput: {
    marginBottom: "2px",
  },
  button: {
    position: "relative",
    marginLeft: "-14px",
    marginTop: "-2px",
    padding: "8px 12px",
    backgroundColor: "rgb(108, 92, 231)",
    color: "rgb(255, 255, 255)",
    border: "none",
    height: "42.17px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderTopRightRadius: "7.5px",
    borderBottomRightRadius: "7.5px",
    cursor: "pointer",
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "6px 8px 0 8px",
    marginTop: "20px",
    backgroundColor: "#f9f9f9",
  },

  cardHeader: { fontSize: "16px", marginBottom: "5px" },

  Downloadallbutton: {

    alignItems: 'center',
    padding: '10px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  Downloadallicon: {
    marginRight: '8px', // Adds spacing between the icon and text
  },
};



// Css--------------------------------------------------------------Css-------------------------------------------------------
export default ExecutionDoc;
